var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }